import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, inject, OnDestroy, PLATFORM_ID } from '@angular/core';
import { NotificationService } from '../../services/notifications-service';
import { WebSocketsService } from '../../services/web-sockets.service';
import Swal from 'sweetalert2';
import { Subject, takeUntil } from 'rxjs';
import { ApiService } from '../../services/api/api.service';
import { API_ENDPOINTS } from '../../services/api/api-endpoints';
import { environment } from '../../../../environments/environment';

interface notificationList {
  count: number;
  next: string;
  previous: string;
  results: [];
}
@Component({
  selector: 'app-notification-bell',
  imports: [CommonModule],
  templateUrl: './notification-bell.component.html',
  styleUrl: './notification-bell.component.scss'
})
export class NotificationBellComponent implements OnDestroy {
  private destroy$ = new Subject<void>();
  notificationCount: number = 0;
  notificationMessages: any[] = [];
  isOpen: boolean = false;
  message: string = '';

  assetUrl = environment.assetBaseUrl

  constructor(
    private apiService: ApiService, private notificationService: NotificationService, private socketsService: WebSocketsService, @Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      this.platformServicesSubscription();
    }
    this.notificationService.getAllNotificationsFromServer().pipe(takeUntil(this.destroy$)).subscribe();

  }

  ngOnInit() {

    if (isPlatformBrowser(this.platformId)) {
      // this.notificationService.getNotificationByType('notification').subscribe((data) => {

      //   if (data) {
      //     if (data.type === 'notification') {

      //       Swal.fire({
      //         // icon: 'info',
      //         imageUrl: this.assetUrl + 'icons/bell-2.svg', // your own icon path
      //         imageWidth: 30,
      //         imageHeight: 30,
      //         // title: 'Upcoming Appointment',
      //         html: 'You have an appointment on <b>Oct 26, 2025</b> at <b>3:00 PM</b>.',
      //         showConfirmButton: false,
      //         timer: 4000,
      //         timerProgressBar: true,
      //         background: '#fff',
      //         customClass: {
      //           popup: '!flex items-center rounded-lg shadow-lg border border-gray-200 p-1 mt-[80px]',
      //           title: 'text-gray-800 text-lg font-semibold',
      //           htmlContainer: 'text-sm text-gray-600',
      //           image: 'm-0',
      //         },
      //         position: "top-end",
      //         toast: true,
      //       });

      //     }
      //   }
      // });

      // setTimeout(() => {
      //   this.socketsService.send({ message: 'Appointment1 status changed', type: 'notification' });
      // }, 8000);
      // setTimeout(() => {
      //   this.socketsService.send({ message: 'User1 booken appointment', type: 'notification' });
      // }, 7000);
      // setTimeout(() => {
      //   this.socketsService.send({ message: 'Hello from Angular!', type: 'chat' });
      // }, 6000);
      // setTimeout(() => {
      //   this.socketsService.send({ message: 'Appointment1 status changed', type: 'notification' });
      // }, 8000);
      // setTimeout(() => {
      //   this.socketsService.send({ message: 'User1 booken appointment', type: 'notification' });
      // }, 7000);
      // setTimeout(() => {
      //   this.socketsService.send({ message: 'Appointment1 status changed', type: 'notification' });
      // }, 8000);
      // setTimeout(() => {
      //   this.socketsService.send({ message: 'User1 booken appointment', type: 'notification' });
      // }, 7000);
      // setTimeout(() => {
      //   this.socketsService.send({ message: 'Appointment1 status changed', type: 'notification' });
      // }, 8000);
      // setTimeout(() => {
      //   this.socketsService.send({ message: 'User1 booken appointment', type: 'notification' });
      // }, 7000);
      // setTimeout(() => {
      //   this.socketsService.send({ message: 'Hello from Angular!', type: 'chat' });
      // }, 6000);
    }
  }

  platformServicesSubscription() {

    if (isPlatformBrowser(this.platformId)) {

      this.notificationService.count$.pipe(takeUntil(this.destroy$)).subscribe((count) => {
        this.notificationCount = count
      });

      this.notificationService.message$.pipe(takeUntil(this.destroy$)).subscribe((message) => {

        this.notificationMessages = message;
    
      });



      this.notificationService.getNotifications().pipe(takeUntil(this.destroy$)).subscribe((data) => {
        
        if (data) {
          if (data.type === "echo") return

          if (data.type === 'Notification' || data.type === 'alert' || data.type === 'reminder') {
            this.message = data.title || 'You have a new notification.'
            setTimeout(() => {
              Swal.fire({
                // icon: 'info',
                // imageUrl: this.assetUrl + 'icons/bell-2.svg',
                imageWidth: 30,
                imageHeight: 30,
                // title: data.message.title || 'New Notification',
                html: data.title || 'You have a new notification.',
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
                background: '#fff',
                customClass: {
                  container: '!z-[999999999]',
                  popup: '!flex items-center rounded-lg shadow-lg border border-gray-200 p-1 mt-[80px]',
                  title: 'text-gray-800 text-lg font-semibold',
                  htmlContainer: 'text-sm text-gray-600 flex direction-row gap-1',
                  image: 'm-0',
                },
                position: "top-end",
                toast: true,
              });

                  this.playNotificationSound()
            }, 5000)

          }

        }
      });
    }

  }

  playNotificationSound() {
    const audio = new Audio();
    audio.src = this.assetUrl + 'sounds/notification-alert.mp3';
    audio.load();
    audio.play();
  }

  openNotifications() {
    this.isOpen = !this.isOpen;
    // if (!this.isOpen) {
    //   this.notificationService.markAllAsRead();
    // }

  }

  clearNotifications() {
    this.notificationService.clearAll().pipe(takeUntil(this.destroy$)).subscribe();
    this.isOpen = false;
  }

  markAllAsRead() {
    this.notificationService.markAllAsRead().pipe(takeUntil(this.destroy$)).subscribe();
    this.isOpen = false;
  }

  markOneAsRead(id: string) {
    this.notificationService.markOneAsRead(id).pipe(takeUntil(this.destroy$)).subscribe();
  }

  markLoginAsRead(id: string) {
    this.notificationService.markLoginAsRead(id);
  }

  clearOne(id: string) {
    this.notificationService.deleteNotification(id).pipe(takeUntil(this.destroy$)).subscribe();
  }
  clearLogin(id: string) {
    this.notificationService.deleteLoginNotification(id);
  }

  closeDropdown() {
    this.isOpen = false;
  }

  ngOnDestroy() {
    console.log("DESTROYED CALLED, next, complete destroy$");
    this.destroy$.next();
    this.destroy$.complete();
    // this.notificationService.markAllAsRead();
  }
}
